export const profileHeaders = [
  { key: "businessName", label: "Business Name" },
  { key: "primaryContactName", label: "Primary Contact Name" },
  { key: "businessType", label: "Business Type" },
  { key: "businessEmail", label: "Business Email" },
  { key: "businessPhone", label: "Business Phone" },
];

export const plannerProfileFilterOptions = [
  {
    label: "Business Name",
    value: "businessName",
    type: "text",
  },
  {
    label: "Business Type",
    value: "businessType",
    type: "checkbox",
    options: [
      {
        value: "Preneed Planner",
        label: "Preneed Planner",
      },
    ],
  },
];
